import { render, staticRenderFns } from "./PencilIcon.vue?vue&type=template&id=95a96e98&"
import script from "./PencilIcon.vue?vue&type=script&lang=ts&"
export * from "./PencilIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports